import { render, staticRenderFns } from "./SaleRecoveryFilter.vue?vue&type=template&id=9978d468&"
import script from "./SaleRecoveryFilter.vue?vue&type=script&lang=js&"
export * from "./SaleRecoveryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports